var React = require('react');

function CO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M85.28 19.040l-0.4-14.72-39.68 0.64-38.88-0.8-2.32 59.12 42.72 0.88 40.64-0.88z"}));
}

CO.defaultProps = {"version":"1.1","width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = CO;

CO.default = CO;
